
import { defineComponent } from 'vue';
import type { PropType } from 'vue';

function isHTMLElement(element: any): element is HTMLElement {
	return element && element instanceof HTMLElement;
}

export default defineComponent({
	name: 'Accordion',
	data() {
		return {
			selectedIndex: -1
		};
	},
	computed: {
		descriptionClass() {
			let descriptionClasses = ['p-3', 'bg-color-grey-lightest'];
			switch (this.styling) {
				case 'user':
					descriptionClasses = ['p-3', 'bg-color-grey-lightest'];
					break;
				case 'company':
					descriptionClasses = ['p-3', 'bg-color-grey-light'];
					break;
				default:
					break;
			}
			return descriptionClasses;
		}
	},
	methods: {
		select(index) {
			if (this.selectedIndex === index) {
				this.selectedIndex = -1;
			} else {
				this.selectedIndex = index;
				this.$emit('selected', this._uid, this.selectedIndex);
			}
			if (this.$isMobile.phone && this.selectedIndex !== -1) {
				const element = this.$refs['active-true'];
				if (isHTMLElement(element)) {
					element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		},
		active(index): boolean {
			return this.selectedIndex === index && this.selectedaccordion === this._uid;
		},
		titleClass(index) {
			let titleClasses: string[] | {}[];
			switch (this.styling) {
				case 'company':
					titleClasses = [
						'font-bold',
						'text-lg',
						'cursor-pointer',
						'p-3',
						'trans-all-300',
						{
							'text-color-white bg-color-main-business': this.active(index),
							'hover:text-color-main-business hover:bg-color-grey-light': !this.active(index)
						}
					];
					break;
				case 'user':
					titleClasses = [
						'font-bold',
						'text-lg',
						'cursor-pointer',
						'trans-all-300',
						{
							'text-color-white bg-color-main': this.active(index),
							'hover:text-color-main hover:bg-color-grey-lightest': !this.active(index)
						}
					];
					break;
				default:
					titleClasses = [
						'text-md',
						'cursor-pointer',
						'p-2',
						{
							'text-color-white bg-color-main': this.active(index),
							'hover:text-color-main hover:bg-color-grey-lightest': !this.active(index)
						}
					];
					break;
			}
			return titleClasses;
		}
	},
	props: {
		selectedaccordion: { type: Number, required: false },
		icon: { type: String, required: false },
		title: { type: String, required: false },
		items: {
			type: Array as PropType<{ id: string; title: string; description: string }[]>,
			required: true
		},
		styling: {
			type: String,
			default: 'default',
			validator: (value: string) => ['default', 'user', 'company'].includes(value)
		}
	}
});
